module.exports = __webpack_public_path__ + "media/images/home/icon-check-3c9fbf826af733258d5253f56687ff07.svg";